export enum COLLECTION_CONTENT_TYPE {
  BANNER = 'BANNER',
  PRODUCT = 'PRODUCT',
  TESTIMONY = 'TESTIMONY',
  CATEGORY = 'CATEGORY',
}

export enum COLLECTION_BANNER_TYPE {
  SIMPLE_BANNER = 'SIMPLE_BANNER',
  SIDE_BY_SIDE_BANNER = 'SIDE_BY_SIDE_BANNER',
  GRID_BANNER = 'GRID_BANNER',
  MULTI_BANNER = 'MULTI_BANNER',
}

export enum COLLECTION_BANNERS_POSITION {
  FREE = 'FREE',
  HOME_TOP = 'HOME_TOP',
  HOME_SECOND_BANNER = 'HOME_SECOND_BANNER',
  HOME_THIRD_BANNER = 'HOME_THIRD_BANNER',
  HOME_FOURTH_BANNER = 'HOME_FOURTH_BANNER',
  HOME_FIFTH_BANNER = 'HOME_FIFTH_BANNER',
  HOME_SIX_BANNER = 'HOME_SIX_BANNER',
  HOME_SEVEN_BANNER = 'HOME_SEVEN_BANNER',
}

export enum COLLECTION_PRODUCTS_POSITION {
  FREE = 'FREE',
  HOME_FIRST_PRODUCTS = 'HOME_FIRST_PRODUCTS',
  HOME_SECOND_PRODUCTS = 'HOME_SECOND_PRODUCTS',
  HOME_THIRD_PRODUCTS = 'HOME_THIRD_PRODUCTS',
  HOME_FOURTH_PRODUCTS = 'HOME_FOURTH_PRODUCTS',
  HOME_FIFTH_PRODUCTS = 'HOME_FIFTH_PRODUCTS',
  HOME_SIX_PRODUCTS = 'HOME_SIX_PRODUCTS',
  HOME_SEVEN_PRODUCTS = 'HOME_SEVEN_PRODUCTS',
  HOME_EIGHT_PRODUCTS = 'HOME_EIGHT_PRODUCTS',
  HOME_NINE_PRODUCTS = 'HOME_NINE_PRODUCTS',
  HOME_TEN_PRODUCTS = 'HOME_TEN_PRODUCTS',
  HOME_ELEVEN_PRODUCTS = 'HOME_ELEVEN_PRODUCTS',
  HOME_TWELVE_PRODUCTS = 'HOME_TWELVE_PRODUCTS',
  HOME_THIRTEEN_PRODUCTS = 'HOME_THIRTEEN_PRODUCTS',
  HOME_FOURTEEN_PRODUCTS = 'HOME_FOURTEEN_PRODUCTS',
  HOME_FIFTEEN_PRODUCTS = 'HOME_FIFTEEN_PRODUCTS',
  HOME_SIXTEEN_PRODUCTS = 'HOME_SIXTEEN_PRODUCTS',
  HOME_SEVENTEEN_PRODUCTS = 'HOME_SEVENTEEN_PRODUCTS',
  HOME_EIGHTEEN_PRODUCTS = 'HOME_EIGHTEEN_PRODUCTS',
  HOME_NINETEEN_PRODUCTS = 'HOME_NINETEEN_PRODUCTS',
  HOME_TWENTY_PRODUCTS = 'HOME_TWENTY_PRODUCTS',
}

export enum DYNAMIC_COLLECTION_TYPE {
  CUSTOM = 'CUSTOM',
  MOST_RECENT = 'MOST_RECENT',
  MOST_VOTED = 'MOST_VOTED',
  MOST_SOLD = 'MOST_SOLD',
  OFFER_PRODUCTS = 'OFFER_PRODUCTS',
  RECOMMENDED = 'RECOMMENDED',
  CUSTOM_FILTER = 'CUSTOM_FILTER',
}

export const COLLECTION_BANNER_TYPE_COLOR = {
  [COLLECTION_BANNER_TYPE.SIMPLE_BANNER]: '#FDA20A',
  [COLLECTION_BANNER_TYPE.MULTI_BANNER]: '#37AEFF',
  [COLLECTION_BANNER_TYPE.SIDE_BY_SIDE_BANNER]: '#02B389',
  [COLLECTION_BANNER_TYPE.GRID_BANNER]: '#02B389',
};

export const BANNER_GRID_PRESETS: { [key in COLLECTION_BANNER_TYPE]: Array<{ label: string; value: number[] }> } = {
  [COLLECTION_BANNER_TYPE.SIMPLE_BANNER]: [{ label: '12', value: [12] }],
  [COLLECTION_BANNER_TYPE.SIDE_BY_SIDE_BANNER]: [{ label: '6-6', value: [6, 6] }],
  [COLLECTION_BANNER_TYPE.GRID_BANNER]: [
    { label: '3-9', value: [3, 9] },
    { label: '9-3', value: [9, 3] },
    { label: '4-4-4', value: [4, 4, 4] },
    { label: '6-6', value: [6, 6] },
    { label: '4-8', value: [4, 8] },
    { label: '8-4', value: [8, 4] },
    { label: '5-7', value: [5, 7] },
    { label: '7-5', value: [7, 5] },
  ],
  [COLLECTION_BANNER_TYPE.MULTI_BANNER]: [
    { label: '4-4-4', value: [4, 4, 4] },
    { label: '3-3-3-3', value: [3, 3, 3, 3] },
    { label: '6-6', value: [6, 6] },
  ],
};

export const DYNAMIC_COLLECTION_TYPE_COLORS: { [key in DYNAMIC_COLLECTION_TYPE]: string } = {
  [DYNAMIC_COLLECTION_TYPE.MOST_RECENT]: '#3498db',
  [DYNAMIC_COLLECTION_TYPE.MOST_VOTED]: '#f1c40f',
  [DYNAMIC_COLLECTION_TYPE.MOST_SOLD]: '#2ecc71',
  [DYNAMIC_COLLECTION_TYPE.OFFER_PRODUCTS]: '#e74c3c',
  [DYNAMIC_COLLECTION_TYPE.RECOMMENDED]: '#9b59b6',
  [DYNAMIC_COLLECTION_TYPE.CUSTOM]: '#95a5a6',
  [DYNAMIC_COLLECTION_TYPE.CUSTOM_FILTER]: '#54B316',
};

export const POSITION_COLLECTION_COLORS: {
  [key in COLLECTION_BANNERS_POSITION | COLLECTION_PRODUCTS_POSITION]: string;
} = {
  [COLLECTION_BANNERS_POSITION.FREE]: '#54B316', // Verde azulado
  [COLLECTION_BANNERS_POSITION.HOME_FIFTH_BANNER]: '#254EDB', // Naranja oscuro
  [COLLECTION_BANNERS_POSITION.HOME_FOURTH_BANNER]: '#1AADD1', // Púrpura
  [COLLECTION_BANNERS_POSITION.HOME_SECOND_BANNER]: '#B79D00', // Naranja quemado
  [COLLECTION_BANNERS_POSITION.HOME_THIRD_BANNER]: '#c0392b', // Rojo oscuro
  [COLLECTION_BANNERS_POSITION.HOME_TOP]: '#95a5a6', // Gris azulado
  [COLLECTION_BANNERS_POSITION.HOME_SIX_BANNER]: '#729193', // Gris azulado
  [COLLECTION_BANNERS_POSITION.HOME_SEVEN_BANNER]: '#376668', // Gris azulado
  [COLLECTION_PRODUCTS_POSITION.HOME_FIRST_PRODUCTS]: '#2c3e50', // Azul oscuro
  [COLLECTION_PRODUCTS_POSITION.HOME_SECOND_PRODUCTS]: '#c0392b', // Morado oscuro
  [COLLECTION_PRODUCTS_POSITION.HOME_THIRD_PRODUCTS]: '#16a085', // Verde esmeralda
  [COLLECTION_PRODUCTS_POSITION.HOME_FOURTH_PRODUCTS]: '#254EDB', // Azul fuerte
  [COLLECTION_PRODUCTS_POSITION.HOME_FIFTH_PRODUCTS]: '#e67e22', // Naranja
  [COLLECTION_PRODUCTS_POSITION.HOME_SIX_PRODUCTS]: '#8e44ad', // Púrpura
  [COLLECTION_PRODUCTS_POSITION.HOME_SEVEN_PRODUCTS]: '#27ae60', // Verde
  [COLLECTION_PRODUCTS_POSITION.HOME_EIGHT_PRODUCTS]: '#2980b9', // Azul
  [COLLECTION_PRODUCTS_POSITION.HOME_NINE_PRODUCTS]: '#d35400', // Naranja oscuro
  [COLLECTION_PRODUCTS_POSITION.HOME_TEN_PRODUCTS]: '#7f8c8d', // Gris
  [COLLECTION_PRODUCTS_POSITION.HOME_ELEVEN_PRODUCTS]: '#16a085', // Verde azulado
  [COLLECTION_PRODUCTS_POSITION.HOME_TWELVE_PRODUCTS]: '#f39c12', // Amarillo dorado
  [COLLECTION_PRODUCTS_POSITION.HOME_THIRTEEN_PRODUCTS]: '#34495e', // Gris oscuro
  [COLLECTION_PRODUCTS_POSITION.HOME_FOURTEEN_PRODUCTS]: '#e74c3c', // Rojo
  [COLLECTION_PRODUCTS_POSITION.HOME_FIFTEEN_PRODUCTS]: '#3498db', // Azul claro
  [COLLECTION_PRODUCTS_POSITION.HOME_SIXTEEN_PRODUCTS]: '#2ecc71', // Verde brillante
  [COLLECTION_PRODUCTS_POSITION.HOME_SEVENTEEN_PRODUCTS]: '#9b59b6', // Púrpura brillante
  [COLLECTION_PRODUCTS_POSITION.HOME_EIGHTEEN_PRODUCTS]: '#1abc9c', // Turquesa
  [COLLECTION_PRODUCTS_POSITION.HOME_NINETEEN_PRODUCTS]: '#f39c12', // Naranja brillante
  [COLLECTION_PRODUCTS_POSITION.HOME_TWENTY_PRODUCTS]: '#95a5a6', // Gris azulado
};

// export const collectionContentTypeOptions = Object.entries(COLLECTION_CONTENT_TYPE);

// export const dynamicTypeOptions = Object.entries(DYNAMIC_COLLECTION_TYPE);

export type COLLECTION_POSITION = COLLECTION_BANNERS_POSITION | COLLECTION_PRODUCTS_POSITION;
// export type COLLECTION_DYNAMIC = COLLECTION_BANNERS_POSITION | COLLECTION_PRODUCTS_POSITION;

export const COLLECTION_ROUTER: Record<COLLECTION_CONTENT_TYPE, string> = {
  [COLLECTION_CONTENT_TYPE.BANNER]: 'banners',
  [COLLECTION_CONTENT_TYPE.PRODUCT]: 'products',
  [COLLECTION_CONTENT_TYPE.CATEGORY]: 'categories',
  [COLLECTION_CONTENT_TYPE.TESTIMONY]: 'testimonials',
};

export const getContentTypeKeyByValue = (value: string): COLLECTION_CONTENT_TYPE | undefined => {
  const entries = Object.entries(COLLECTION_ROUTER) as Array<[COLLECTION_CONTENT_TYPE, string]>;
  for (const [key, val] of entries) {
    if (val === value) {
      return key;
    }
  }
  return undefined;
};
